import * as utils from "./misc.js";
import * as tracking from './tracking.js';

function sendchatmessage(thismessage) {

    var threadid = utils.getCookie("cc_threadid");
    var messagesent;
    var offline = thismessage.offline;
    if (utils.isnull(threadid)) {
        var data = {
            event: "generate_lead",
            eventLabel: "Online Chat Enquiry",
            eventName: "Online Chat Enquiry"
        }

        tracking.pushtodatalayer(data);

    }
    if (offline) {
        jQuery(".chats .messages").html("Thanks! We've sent your message and will respond as soon as we can.");
        jQuery(".welcomechat").remove();
    }
    else {
        chattimeout(true, false);
        if (!isnull(thismessage.sent)) {
            messagesent = thismessage.sent;
        }
        else {
            messagesent = "...sending";
        }
        jQuery(".chats .messages").html(jQuery(".chats .messages").html() + displaychatmessage({ message: thismessage.message, sent: messagesent }));
        jQuery(".welcomechat").remove();
    }

    jQuery.post(base.ajaxurl, {
        action: "sendchatmessage",
        message: thismessage.message,
        name: thismessage.name,
        subject: thismessage.subject,
        email: thismessage.email,
        pageurl: window.location.href,
        threadid: threadid,
        offline: offline
    }, function (r) {
        var r = JSON.parse(r);
        if (r) {
            threadid = r.threadid;

            if (offline) {
                jQuery(".chats .messages").html("Thanks! We've sent your message and will respond as soon as we can.");
                jQuery(".welcomechat").remove();
            }
            else {
                utils.setCookie("cc_threadid", threadid);
                loadtranscript();
            }

        }
    });
}

export function init() {

    //console.log("init chatbox");
    var chatthread = utils.getCookie("cc_threadid");

    jQuery(".chatbox").on("click", ".close", function () {
        jQuery(".chatbox").removeClass("open");
    })

    jQuery(".openchat").on("click", function () {
        jQuery(this).parent(".chatbox").addClass("open");


        if (jQuery(".chatbox").attr("data-chatonline")) {

            doChat();
        }


    });

    jQuery(".chatbox").on("click", "button[name='sendchatmessage']", function () {
        var name = jQuery(".welcomechat input[name='name']").val();
        var email = jQuery(".welcomechat input[name='email']").val();
        var subject = jQuery(".welcomechat input[name='subject']").val();
        var offline = false;
        var send = true;
        if (jQuery(".welcomechat").length > 0) {
            if (jQuery(".welcomechat").hasClass("offline")) {
                offline = true;
            }
            var message = jQuery(".welcomechat textarea[name='message']").val();
            if (name == "" || email == "" || message == "") {
                send = false;
            }
        }
        else {
            var message = jQuery(".newmessagebox textarea[name='message']").val();
        }
        if (send) {
            jQuery("textarea[name='message']").val("");

            sendchatmessage({ "offline": offline, "name": name, "subject": subject, "email": email, "message": message });

        }
        else {
            alert("please enter your name and email");
        }
    })
}

var count;
function chattimeout(reset = false, inc = false) {

    if (!count && count != 0) { count = 0; }
    if (inc) { count += 1 }
    if (reset) { count = 0; }
    return count;
}

function loadtranscript(chatthread) {
    var threadid = chatthread;
    var noresponse = chattimeout(false, false);
    var messages = jQuery(".chats .messages").html();
    if (noresponse > 5) {
        jQuery(".newmessagebox").hide();
        jQuery(".chats .messages").html("<span class='noresponse'>This is taking a while... but we're still here...</span>" + messages);
    }
    else if (noresponse > 10) {
        jQuery(".newmessagebox").hide();
        jQuery(".chats .messages").html("<span class='noresponse'>There is currently no one available to talk. Your messages have been sent and we will reply via email as soon as someone is available</span>");
    }
    else {
        if (threadid != "") {
            jQuery(".chats .newmessagebox").show();
            jQuery.post(base.ajaxurl, {
                action: "getchat",
                threadid: threadid
            }, function (r) {
                var r = JSON.parse(r);

                if (r) {
                    jQuery(".chatsloading").remove();
                    var rchats = (r.chats) ? r.chats : [];
                    var transcript = "";
                    for (var a = 0; a < rchats.length; a++) {
                        var created = r.chats[a].created;
                        var message = r.chats[a].message;
                        var userid = r.chats[a].userid;

                        transcript += displaychatmessage({ userid: userid, message: message, delivered: created });
                    }


                    if (transcript == jQuery(".chats .messages").html());
                    {
                        chattimeout(false, true);
                    }
                    jQuery(".chats .messages").html(transcript);
                }
            });

            setTimeout(loadtranscript, 10000);
        }
    }

}

function displaychatmessage(details) {
    var datedesc = (!isnull(details.delivered)) ? "Delivered" : "Sent";
    var datedate = (!isnull(details.delivered)) ? details.delivered : details.sent;
    var usercc = (!isnull(details.userid)) ? "cc" : "user";

    return "<div class='newmessage " + usercc + "'><div class='message'>" + details.message + "</div><div class='delivered'><small>" + datedesc + " " + datedate + "</small></div></div>";
}

function doChat() {
    jQuery(".chats .newmessagebox").html(`Message: <textarea name='message'></textarea><br />
            <button name='sendchatmessage'>Send Message</button>`);
    if (utils.isnull(chatthread)) {
        jQuery(".welcomechat").show();
        jQuery(".chats .newmessagebox").hide();
    }
    else {
        jQuery(".welcomechat").remove();
        jQuery(".messages").html("<p align='center'><img src='/wp-content/themes/cargocycles/assets/images/ajax-loading.gif' class='chatsloading'></p>");

        loadtranscript(chatthread);
    }

    // if (jQuery(".chatsloading").length <= 0)
    // {
    //     jQuery("<p align='center'><img src='/wp-content/themes/cargocycles/assets/images/ajax-loading.gif' class='chatsloading'></p>").appendTo(".chats");
    // }
}
